//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DateNameFormatter, vehicleProvisionSummaryMixin } from './VehicleProvisionSummaryMixin.js'
import cloneDeep from 'lodash.clonedeep'

export default {
  name: 'VehicleProvisionSummary',
  mixins: [vehicleProvisionSummaryMixin],
  props: {
    minimized: {
      type: Boolean,
      default: false
    },
    excludePast: {
      type: Boolean,
      default: false
    },
    excludeCurrent: {
      type: Boolean,
      default: false
    },
    includeFutureCount: {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      columns: this.getColumns(),
      pagination: {
        page: 1,
        rowsPerPage: 0 // все строки
      }
    }
  },
  computed: {
    allValues: function () {
      const rows = []
      if (this.summary.intervals) {
        const dateNameFormatter = new DateNameFormatter()
        const currentTime = new Date().getTime()

        let futureCount = 0
        const maxFutureCount = this.includeFutureCount
        for (const interval of this.summary.intervals) {
          const startTime = interval.startTime
          const endTime = interval.endTime
          const timeType = endTime <= currentTime ? 'past' : startTime < currentTime ? 'current' : 'future'

          if (timeType === 'past') {
            if (this.excludePast) {
              continue
            }
          } else if (timeType === 'current') {
            if (this.excludeCurrent) {
              continue
            }
          } else if (timeType === 'future') {
            futureCount++
            if (maxFutureCount != null && maxFutureCount < futureCount) {
              continue
            }
          }

          rows.push({
            name: this.getIntervalName(interval, dateNameFormatter),
            startTime: startTime,
            _interval: interval,
            _timeType: timeType,
            _type: 'intervalInfo'
          })

          for (const value of interval.values) {
            if ((value.notCanceled == null || value.notCanceled === 0) && value.reserved == null && value.name !== 'Все направления') {
              continue
            }

            const row = cloneDeep(value)
            row._interval = interval
            row._timeType = timeType
            row._type = 'value'

            rows.push(row)
          }
        }
      }
      return rows
    }
  },
  methods: {
    getColumns: function () {
      const nameColumn = {
        name: 'name',
        label: 'Направление',
        align: 'right',
        field: 'name',
        sortable: false
      }

      if (this.minimized) {
        return [
          nameColumn,
          ...this.getBaseColumns().filter(column => column.name === 'notCanceled' || column.name === 'reserved')
        ]
      } else {
        return [
          nameColumn,
          ...this.getBaseColumns(),
          {
            name: 'closed',
            label: 'Закрыто',
            align: 'right',
            field: 'closed',
            sortable: false
          }
        ]
      }
    },
    getTrStyle: function (row) {
      if (row._type === 'intervalInfo' || row.total) {
        return 'font-weight: 500;'
      }
      return ''
    },
    getTdStyle: function (row, col) {
      if (row._type === 'intervalInfo') {
        return this.getIntervalStyle(row._interval)
      } else if (col && col.name === 'name') {
        return this.getIntervalStyle(row._interval)
      } else if (col && col.name === 'reserved') {
        if (col.value) {
          if (col.value > 0) {
            return this.getCellStyle('#68f168', 'black')
          } else {
            return this.getCellStyle('#ffcece', 'black')
          }
        }
      }
    }
  }
}

